import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { StockTag } from '@pulpo/pulpo-models';
import { StockTagService } from '@pulpo/pulpo-api';
import { CommonModule, DatePipe } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { StockTagDateListPipe } from '../../pipes';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'last-stock-tag-list',
  templateUrl: './last-stock-tag-list.component.html',
  styleUrls: ['./last-stock-tag-list.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    DatePipe,
    MatProgressSpinnerModule,
    CommonModule,
    StockTagDateListPipe,
  ],
})
export class LastStockTagListComponent implements OnInit {
  displayedColumns: string[] = [
    'date',
    'stockReference',
    'productReferences',
    'relatedDateList',
    'actions',
  ];

  //List
  dataSource!: MatTableDataSource<StockTag>;
  loading = true;

  constructor(
    private stockTagService: StockTagService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.dataSource = new MatTableDataSource();
    this.refreshReports();
  }

  private refreshReports() {
    this.loading = true;
    this.stockTagService.getUnreadStockTags().subscribe(
      (res: any) => {
        this.loading = false;
        this.dataSource = new MatTableDataSource(res.body || []);
        this.cdr.markForCheck();
      },
      () => {
        this.loading = false;
        this.cdr.markForCheck();
      }
    );
  }

  markAsRead(stockTag: StockTag) {
    this.stockTagService.markAsRead(stockTag).subscribe(() => {
      this.refreshReports();
      this.cdr.markForCheck();
    });
  }
}
